<template>
  <div class="script-tab">
    <div class="slide">
      <div class="title">
        <img :src="title">
      </div>
    </div>
    <div class="list-wrapper">
      <Search
        :filterList="searchFilter"
        @search="subminSearch"
        @offsearch="offSearch"
      ></Search>
      <m-textArea class="data-list" ref="dataList">
        <div class="pdf-list">
          <div
            v-for="(item, index) in datalist"
            :key="index"
            class="pdf-item"
            @click="$emit('pdfshow', item)"
          >
            <div class="pdf-cover">
              <img :src="item.cover | picture">
            </div>
            <div class="pdf-tt">
              {{item.title}}
            </div>
          </div>
        </div>
        <Pagination
          :num="pageNow"
          :pages="pages"
          @change="chagenPage"
        ></Pagination>
      </m-textArea>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

import Search from "@/components/Search.vue";
import GisBtn from "@/components/GisBtn.vue";
import TextArea from "@/components/TextArea";
import Pagination from "@/components/Pagination";

export default {
  props: {
    tabData: Object
  },
  components: {
    Search,
    GisBtn,
    "m-textArea": TextArea,
    Pagination
  },
  data() {
    return {
      pageName: "video-record",
      onSearch: false,
      category: "",
      searchFilter: [
        { name: "title", title: "题名" },
        { name: "charge", title: "责任者" },
        { name: "region", title: "地域" }
      ],
      searchParam: {}
    };
  },
  computed: {
    ...mapState(["video-record", "dataApi"]),
    datalist() {
      if (this.onSearch) {
        return this["video-record"].searchres.content;
      }
      return this["video-record"][this.pageNow];
    },
    pageNow() {
      return this.onSearch
        ? this["video-record"].searchres.number
        : this["video-record"].number;
    },
    pages() {
      return this.onSearch
        ? this["video-record"].searchres.total_pages
        : this["video-record"].total_pages;
    },
    title() {
      return this.tabData.ttimg;
    }
  },
  mounted() {
    this.getPageData();
  },
  filters: {
    picture(value) {
      return "http://shadow.caa.edu.cn" + value;
    }
  },
  methods: {
    ...mapActions(["getDataList", "searchData"]),
    getPageData(page_num = 0) {
      const param = {
        data_name: this.pageName,
        page_num
      };
      this.getDataList(param);
    },
    chagenPage(num) {
      this.onSearch
        ? this.search(this.searchParam, num)
        : this.getPageData(num);
      this.$refs.dataList.scroll();
    },
    search(param, num = 0) {
      this.searchData({
        data_name: this.pageName,
        page_num: num,
        ...param
      });
      this.searchParam = param;
      this.onSearch = true;
    },
    subminSearch(data) {
      const { category, ...param } = data;

      if (category) {
        param.speciality = category;
      }

      this.search(param);
      this.$refs.dataList.scroll();
    },
    offSearch() {
      this.getPageData();
      this.onSearch = false;
      this.$refs.dataList.scroll();
    }
  }
};
</script>

<style lang="scss">
@import "../../assets/base";
.script-tab {
  position: relative;
  display: flex;
  height: 73vh;
  padding: 1rem 1rem 0;
  overflow: hidden;

  .slide {
    position: relative;
    flex: 1;

    .title {
      position: absolute;
      top: 3rem;
      @include scaleimg(0.5);
    }

    .gisbtn {
      position: absolute;
      left: 0.5rem;
      bottom: 1rem;
    }
  }

  .list-wrapper {
    flex: 5;
    display: flex;
    flex-direction: column;
  }

  .data-list {
    margin-top: 1rem;
    height: auto;
    flex: 1;

    .text-main {
      padding-left: 0.5rem;
      padding-right: 0.5rem;
      padding-bottom: 1rem;
    }
  }

  .pdf-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-bottom: 1rem;
  }

  .pdf-item {
    display: block;
    width: 49%;
    height: 10rem;
    padding: 0.5rem;
    margin-bottom: 0.5rem;
    background-color: #d2c2a3;
    box-sizing: border-box;
    text-align: center;   

    .pdf-cover {
      height: 7.5rem;
      margin-bottom: 0.5rem;

      img {
        max-height: 100%;
      }
    }

    .pdf-tt {
      width: 100%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      font-size: 0.75rem;
    }
  }
}
</style>
